module.exports = __webpack_public_path__ + "img/wz-1-1.896f2c1e.png";